import type { ReactNode } from 'react';
import type { Block } from '@/lib/types';
import { cn } from '@/lib/utils';

const SPACING = { none: 'py-0', sm: 'py-6 md:py-8', md: 'py-10 md:py-14', lg: 'py-14 md:py-20' };
const BG: Record<string, string> = {
  white: 'bg-white',
  muted: 'bg-surface-muted',
  teal: 'bg-brand-900 text-white',
  green: 'bg-forest-800 text-white',
  gold: 'bg-gold-50',
  dark: 'bg-ink text-white',
};
const WIDTH = { narrow: 'max-w-3xl', normal: '', wide: 'max-w-[1440px]' };

/** Device visibility classes: preview iframes and real devices respond to the same breakpoints. */
export function visibilityClass(b: Block) {
  const d = b.visible?.desktop ?? true;
  const m = b.visible?.mobile ?? true;
  if (!d && !m) return 'hidden';
  if (!m) return 'hidden md:block';
  if (!d) return 'md:hidden';
  return '';
}

export const isDark = (b: Block) => ['teal', 'green', 'dark'].includes(b.settings?.background ?? '');

export function Section({ block, children, className, container = true }: { block: Block; children: ReactNode; className?: string; container?: boolean }) {
  const s = block.settings ?? {};
  return (
    <section id={s.anchor || undefined} data-block-id={block.id} data-block-type={block.type} className={cn(SPACING[s.spacing ?? 'md'], BG[s.background ?? 'white'], visibilityClass(block), className)}>
      {container ? <div className={cn('container', WIDTH[s.width ?? 'normal'], s.align === 'center' && 'text-center')}>{children}</div> : children}
    </section>
  );
}
